<template>
  <div class="completed-homework-list-topbar">
    <div class="homework-topbar-top">
      <div class="back">
        <button class="back-button" @click="jumpBack"><i class="iconfont icon-back"/>返回</button>
      </div>
      <div class="homework-title">
        <div class="homework-title-label">作业标题:</div>
        <div class="homework-title-content">
          {{homeworkTopbarData.title}}
        </div>
      </div>
    </div>
    <div class="homework-topbar-bottom">
      <div class="homework-completed-progress">
        <span class="homework-completed-label">班级人数:</span
        ><span class="homework-completed-count">{{homeworkTopbarData.classCount}}</span
        ><span class="homework-completed-label">已提交人数:</span
        ><span class="homework-completed-count">{{homeworkTopbarData.submitCount}}</span
        ><span class="homework-completed-label">已批改数量:</span
        ><span class="homework-completed-count">{{homeworkTopbarData.checkCount}}</span>
      </div>
      <div class="student-homework-search">
        <search class="search" placeholder="输入学生姓名筛选作业" @search="searchHomeworkByStudentName"/>
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  components: {
    search,
  },
  props:{
    homeworkTopbarData:{
      type:Object,
      require:true,
    }
  },
  methods:{
    jumpBack(){
      this.$router.back();
    },
    searchHomeworkByStudentName(keyWord){
      this.$emit('searchHomeworkByStudentName',keyWord);
    }
  }
};
</script>

<style scoped lang="scss">
@import "./completedHomeworkListTopbar.scss";
</style>